import { dashboardFeature } from './dashboard.reducer';

export const {
  selectUser,
  selectLoading: selectUserLoading,
  selectError: selectUserError,
  selectRoles,
  selectRolesLoading,
  selectRolesError,
  selectOwnUnfreezeRequestId,
  selectOwnUnfreezeRequesting,
} = dashboardFeature;
